var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AboutHero'),_c('StorySection'),_c('CoreValues'),_c('TeamSection'),_c('EvolvedSection'),_c('WhatWeDoBest'),_c('CertifiedSection'),_c('GlobalPresence'),_c('ClientsSaySection'),_c('ReadyFightSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }